import { cloneDeep } from '@apollo/client/utilities';
import { EntityInput, forCreate, forDelete, forUpdate } from '../common/entity';
import { KitProduct, KitTemplate } from './kitTemplate';

export class KitTemplateInput extends KitTemplate implements EntityInput<KitTemplate> {
  forCreate(): CreateKitTemplateInput {
    delete (this as any).authorization;
    return CreateKitTemplateInput.from({ ...this }, CreateKitTemplateInput);
  }

  forUpdate(): UpdateKitTemplateInput {
    delete (this as any).authorization;
    return UpdateKitTemplateInput.from({ ...this }, UpdateKitTemplateInput);
  }

  forDelete(): DeleteKitTemplateInput {
    delete (this as any).authorization;
    return DeleteKitTemplateInput.from({ ...this }, DeleteKitTemplateInput);
  }

  validate() {
    if (!this.productMasterDataId) return false;
    if (!this.name) return false;
    if (!this.products.length) return false;
    return true;
  }

  withProductMasterDataId(pmdId?: string) {
    (this.productMasterDataId as any) = pmdId;
    return cloneDeep(this);
  }

  withName(name: string) {
    this.name = name;
    return cloneDeep(this);
  }

  withProduct(product: KitProduct) {
    this.products.push(product);
    return cloneDeep(this);
  }

  withProductQuantity(pmdId: string, quantity: number) {
    const product = this.products.find(p => p.productMasterDataId === pmdId);
    if (!product) return this;

    product.quantity = quantity;
    return cloneDeep(this);
  }

  withoutProduct(pmdId: string) {
    this.products = this.products.filter(p => p.productMasterDataId !== pmdId);
    return cloneDeep(this);
  }

  withProducts(products: KitProduct[]) {
    this.products = products;
    return cloneDeep(this);
  }
}

export class CreateKitTemplateInput extends forCreate(KitTemplateInput) {}

export class UpdateKitTemplateInput extends forUpdate(KitTemplateInput) {}

export class DeleteKitTemplateInput extends forDelete(KitTemplateInput) {}
